export class EditAssessmentDateRequestDto {
  instanceId: string
  newAssessmentDate: Date

  constructor(init?: Partial<EditAssessmentDateRequestDto>) {
    Object.assign(this, init)
  }
}
